import { render, staticRenderFns } from "./JobsImport.vue?vue&type=template&id=246dbdfe&scoped=true"
import script from "./JobsImport.vue?vue&type=script&lang=js"
export * from "./JobsImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246dbdfe",
  null
  
)

export default component.exports